import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { NetworksService } from 'src/app/services/networks/networks.service';

@Component({
    selector: 'app-blockchain-select',
    templateUrl: './blockchain-select.component.html',
    styleUrls: [ './blockchain-select.component.scss' ]
})
export class BlockchainSelectComponent implements OnInit
{
    @Output() onSelect = new EventEmitter<any>();

    public activeNetworks;

    public selectedChain;
    public baseSymbol: string;

    public showSelector: boolean = false;

    constructor(
        private networksService: NetworksService,
    ) { }

    async ngOnInit(): Promise<any>
    {
        const networks = (await this.networksService.getBlockchains() as any).filter(network => network.network);
        this.selectedChain = networks[ 0 ];
        console.log("🚀 ~ file: blockchain-select.component.ts ~ line 26 ~ this.selectedChain", this.selectedChain);
        this.baseSymbol = (await this.networksService.getCoinByChainId(this.selectedChain.chain_id)).symbol;
        this.onSelect.emit({
            network: this.selectedChain,
            symbol: this.baseSymbol
        });
        this.activeNetworks = await Promise.all(networks.map(async (network) =>
        {
            const baseSymbol = (await this.networksService.getCoinByChainId(network.chain_id)).symbol;
            return {
                ...network,
                baseSymbol
            };
        }));
    }

    public selectNetwork(network)
    {
        this.selectedChain = network;
        this.baseSymbol = network.baseSymbol;
        this.onSelect.emit({
            network: this.selectedChain,
            symbol: this.baseSymbol
        });
        this.showSelector = false;
    }
}
